// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3MInp","addWidgetButton":"Header_addWidgetButton___QXLf","dashboardTabs":"Header_dashboardTabs__13Xt5","active":"Header_active__31c6J"};